'use client';

import React from 'react';
import Link from 'next/link';

export default function NotFound() {
  return (
    <main
      className="min-h-screen flex flex-col items-center justify-center"
      style={{ background: '#0A0A0A' }}
    >
      <div className="text-center px-6">
        <p
          style={{
            fontFamily: 'Bebas Neue, sans-serif',
            fontSize: '12px',
            letterSpacing: '6px',
            color: '#AAFF00',
            marginBottom: '16px',
          }}
        >
          404 ERROR
        </p>
        <h1
          style={{
            fontFamily: 'Bebas Neue, sans-serif',
            fontSize: 'clamp(4rem, 15vw, 12rem)',
            lineHeight: 0.88,
            letterSpacing: '2px',
            color: '#FFFFFF',
            marginBottom: '24px',
          }}
        >
          PAGE NOT<br />
          <span style={{ color: '#AAFF00' }}>FOUND.</span>
        </h1>
        <p
          style={{
            fontFamily: 'DM Sans, sans-serif',
            fontSize: '16px',
            color: 'rgba(255,255,255,0.5)',
            marginBottom: '40px',
          }}
        >
          Looks like this page doesn&apos;t exist.
        </p>
        <Link
          href="/home"
          className="btn-lime"
          style={{ fontSize: '12px', letterSpacing: '2.5px', padding: '14px 32px' }}
        >
          Back to Home
        </Link>
      </div>
    </main>
  );
}